/**
 * Palette used to colour job-pipeline stage bars/borders. Cycled by index
 * (`index % borderColors.length`) so any number of stages gets a stable colour.
 *
 * Relocated from `pages/ats-job-details/tabs/JobPipeline/helper` so the Redux
 * pipeline slice can consume it without a store → pages boundary violation.
 */
export const borderColors = ['#B961FF', '#61C6FF', '#FFA361', '#3CCDC4'];
